import { YesObject } from '@yes.technology/react-toolkit'
import { useCallback } from 'react'
import { PatchObjectResponse } from 'shared/types/object.type'
import { useSelectAndLink } from 'site/Renderer/components/SelectAndLink'
import type { FullSelectionOption } from 'site/Renderer/components/SelectAndLink/SelectAndLink.types'
import verifySelectedRelationsLinked from './verifySelectedRelationsLinked'

type Params = {
  selectAndLinkSelectedOptions: FullSelectionOption[] | undefined
  changeAndSave: (
    fieldColumn: string,
    value: YesObject[string]
  ) => Promise<PatchObjectResponse | undefined>
  currentField: string
  relationWorkingSet: YesObject[]
  refetchObjects: () => unknown
  relationCounterpartColumn: string
  fieldValues: YesObject | undefined
  objectclassUuid: string
  onScrollToRelationTable: () => void
}

const useRelationClassRelationSave = ({
  selectAndLinkSelectedOptions,
  changeAndSave,
  currentField,
  relationWorkingSet,
  refetchObjects,
  relationCounterpartColumn,
  fieldValues,
  objectclassUuid,
  onScrollToRelationTable
}: Params) => {
  const { onClearSelection } = useSelectAndLink()

  return useCallback(async () => {
    const sessionSelection = selectAndLinkSelectedOptions
    const response = await changeAndSave(currentField, relationWorkingSet)
    await refetchObjects()

    if (
      !response?.success ||
      !sessionSelection?.length ||
      !relationCounterpartColumn ||
      !fieldValues?.uuid
    ) {
      return
    }

    const verified = await verifySelectedRelationsLinked({
      objectclassUuid,
      relationCounterpartColumn,
      mainObjectUuid: String(fieldValues.uuid),
      selectedUuids: sessionSelection.map((o) => o.uuid)
    })

    if (verified) {
      onClearSelection(currentField)
      onScrollToRelationTable()
    }
  }, [
    selectAndLinkSelectedOptions,
    changeAndSave,
    currentField,
    relationWorkingSet,
    refetchObjects,
    relationCounterpartColumn,
    fieldValues?.uuid,
    objectclassUuid,
    onClearSelection,
    onScrollToRelationTable
  ])
}

export default useRelationClassRelationSave
